import React, { useContext } from 'react';
import './Css/ShopCategory.css';
import { ShopContext } from '../Context/ShopContext';
import dropdown_icon from '../Components/Assets/dropdown_icon.png';
import Item from '../Components/Item/Item';

const ShopCategory = (props) => {

  // const all_product = JSON.parse(localStorage.getItem("all_product"));
  const {all_product} = useContext(ShopContext);
  return (
    <div className='shop-category'>
      <div className="shopcategory-products">
        {all_product.map((item, i)=>{
          if(props.category === item.category) {
            return <Item key={i} id={item.id} name={item.name} img={item.img} price={item.price} quantity={item.quantity}/>
          } else{
            return null;
          }
        })}
      </div>
      <br/>
    </div>  
  )
}

export default ShopCategory